/**
 * Детерминированный PRNG для синхронизированных анимаций у всех юзеров.
 *
 * Идея: все клиенты используют общий "тик" (округлённое время), из
 * которого выводится псевдослучайное число. В один и тот же момент
 * времени все аппы считают одно и то же — картинка на всех экранах
 * совпадает без SSE.
 *
 * Семена — (tickId, variantId) → число [0..1) или целое в [min..max].
 *
 * Используется в NodeOrbit (neural lines, selfDrive), ConnectionStatus
 * и любых других «лайв» UI-элементах, где важна глобальная синхрония.
 */

// Mulberry32 — быстрый маленький PRNG с 32-битным семенем.
function mulberry32(a: number): number {
  let t = (a + 0x6d2b79f5) >>> 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/**
 * Тик-айди: сколько интервалов `intervalMs` прошло с эпохи.
 * Все клиенты дадут одинаковое значение в один момент.
 */
export function currentTick(intervalMs: number): number {
  return Math.floor(Date.now() / intervalMs);
}

/** Псевдослучайное число [0..1) для данной комбинации seed'ов. */
export function syncedRandom(tickId: number, variant = 0): number {
  // Быстрая перемешка двух seed'ов в один 32-битный — Hashing через xorshift.
  const seed = ((tickId * 2654435761) ^ (variant * 1597334677)) >>> 0;
  return mulberry32(seed);
}

/** Целое в [min..max] инклюзивно. */
export function syncedRandomInt(
  tickId: number,
  variant: number,
  min: number,
  max: number,
): number {
  return min + Math.floor(syncedRandom(tickId, variant) * (max - min + 1));
}
